import moment from "moment";
export const isProfilePathname = (pathname: string) => {
    const profilePathRegex = /^\/profile\/\w+\/\w+$/
    return profilePathRegex.test(pathname)
}

export const convertDaysToMonthsAndDays = (totalDays: number) => {
    const duration = moment.duration(totalDays, 'days');
    const months = Math.floor(duration.asMonths()); // Get full months
    const remainingDays = totalDays - moment.duration(months, 'months').asDays(); // Remaining days
    return { months, days: Math.round(remainingDays) };
};
